"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { type ThemeProviderProps } from "next-themes/dist/types";
import useThemeEffect from "../hooks/useThemeEffect";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  useThemeEffect();

  return (
    <NextThemesProvider
      attribute="class"
      enableSystem
      defaultTheme="system"
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
